import { render, staticRenderFns } from "./AccommodationRequestDisplay.vue?vue&type=template&id=87755966&"
import script from "./AccommodationRequestDisplay.vue?vue&type=script&lang=js&"
export * from "./AccommodationRequestDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports